<template>
  <article class="article-card">
    <router-link :to="`/insights/${entry.slug}`" class="article-card__image-link">
      <OptimizedImage :src="entry.image" :alt="entry.title" class="article-card__image" />
      <span class="article-card__badge">{{ entry.category }}</span>
    </router-link>
    <div class="article-card__body">
      <p class="article-card__meta">{{ publishedLabel }}</p>
      <h3 class="article-card__title">
        <router-link :to="`/insights/${entry.slug}`">{{ entry.title }}</router-link>
      </h3>
      <p class="article-card__summary">{{ entry.summary }}</p>
      <router-link :to="`/insights/${entry.slug}`" class="article-card__cta">
        Leer más
      </router-link>
    </div>
  </article>
</template>

<script>
import OptimizedImage from '@/pages/components/OptimizedImage.vue';

export default {
  name: 'ArticleCard',
  components: {
    OptimizedImage
  },
  props: {
    entry: {
      type: Object,
      required: true
    }
  },
  computed: {
    publishedLabel() {
      return new Intl.DateTimeFormat('es-UY', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      }).format(new Date(this.entry.publishedAt));
    }
  }
};
</script>

<style lang="scss" scoped>
.article-card {
  display: grid;
  min-height: 100%;
  background: var(--surface-color);
  border: 1px solid rgba(59, 73, 76, 0.7);
}

.article-card__image-link {
  position: relative;
  display: block;
}

.article-card__badge {
  position: absolute;
  left: 1rem;
  top: 1rem;
  padding: 0.25rem 0.5rem;
  background: rgba(28, 32, 38, 0.9);
  border: 1px solid rgba(59, 73, 76, 0.7);
  color: var(--accent-color);
  font-family: var(--font-mono);
  font-size: 0.65rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.article-card__body {
  display: grid;
  gap: 0.85rem;
  padding: 1.5rem;
}

.article-card__meta {
  margin: 0;
  color: var(--muted-color);
  font-family: var(--font-mono);
  font-size: 0.76rem;
  text-transform: uppercase;
}

.article-card__title {
  margin: 0;

  a {
    color: var(--heading-color);
  }
}

.article-card__summary {
  margin: 0;
  color: var(--text-color);
}

.article-card__cta {
  color: var(--accent-color);
  font-family: var(--font-label);
  font-size: 0.72rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
</style>
